export enum QueryKeys {
  UPDATE_ORDER = 'UPDATE_ORDER',
  GET_ORDER = 'GET_ORDER',
  GET_ORDER_BY_DAY = 'GET_ORDER_BY_DAY',
  GET_MENU_BY_DAY = 'GET_MENU_BY_DAY',
  GET_ORDERING_DEADLINES = 'GET_ORDERING_DEADLINES',
  DELETE_ORDER = 'DELETE_ORDER',
}
